<ion-app>
  <app-side-menu></app-side-menu>
  <ion-router-outlet [animated]="false" id="main-content"></ion-router-outlet>
</ion-app>
